import { gql } from '@apollo/client';

export const CREATE_SURROUNDING_INFORMATION_PROPERTY_LOCALIZATION_MUTATION = gql`
  mutation CreateSurroundingInformationPropertyLocalization(
    $data: updateSurroundingInformationPropertyInput!
  ) {
    createSurroundingInformationPropertyLocalization(input: $data) {
      id
    }
  }
`;
